let truncateText = document.querySelectorAll('.block-truncate-text');
truncateText.forEach(item => {
    const truncateText = truncate(item.innerHTML);
    if (truncateText.readMore) {
        item.innerHTML = truncateText.text;
    }
});
let btnReadMore = document.querySelectorAll('.btn-read-more');
btnReadMore.forEach(item => {
    item.addEventListener('click', function (e) {
        e.preventDefault();
        item.style.display = 'none';
        item.closest('.block-truncate-text').querySelector('.truncate-text').style.display = 'none';
        item.closest('.block-truncate-text').querySelector('.normal-text').style.display = 'block';
    })
});

function truncate(inputText) {
    const maxLengthText = 145;
    let readMore = false;
    if (inputText.length > maxLengthText) {
        inputText = '<div class="truncate-text" style="display:block">' + inputText.substring(0, maxLengthText) + '...</div><a href="#" class="btn-read-more">leer m&aacute;s</a><div class="normal-text" style="display:none">' + inputText + '</div>';
        readMore = true;
    }
    return {'text': inputText, 'readMore': readMore};
}
